import React from "react";
import { Button, SearchBar, Typography } from "@kitbird/core";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import BluebirdLogo from "../../../assets/icons/logogram_bb.png";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { StickyTable } from "../../../components/Table/Table.style";
import BusinessTable from "./components/BusinessTable";
import ModalBusinessForm from "./components/BusinessFormModal";
import useBusiness from "./hooks/useBusiness";
import BusinessDeleteModal from "./components/BusinessDeleteModal";

const Business = () => {
  const useCustomHook = useBusiness();
  const {
    modalFormBusiness,
    setModalFormBusiness,
    setEditValue,
    setParams,
  } = useCustomHook;

  return (
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">Master business</Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BluebirdLogo} alt="" />
            <Typography level={4} fontWeight="medium">
              Daftar master business
            </Typography>
          </TitleContent>
          <ActionSection>
            <SearchBar
              onInputSearch={(val) => setParams((curr) => ({ ...curr, search: val }))}
              hasReset
              placeholder="Cari data"
            />
            <Button
              onClick={() => setModalFormBusiness(true)}
              leftIcon={<PlusIcon />}
            >
              Tambah data
            </Button>
          </ActionSection>
          <StickyTable>
            <BusinessTable
              showModal={() => setModalFormBusiness(true)}
              useCustomHook={useCustomHook}
            />
          </StickyTable>
        </CardContent>
      </PageCard>
      <ModalBusinessForm
        isOpen={modalFormBusiness}
        useCustomHook={useCustomHook}
        setClose={(modalState) => {
          setModalFormBusiness(modalState);
          setEditValue(undefined);
        }}
      />
      <BusinessDeleteModal
        useCustomHook={useCustomHook}
      />
    </PageWrapper>
  );
};

export default Business;
